import React from 'react';
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { DateTime } from 'luxon';
import { NoValue } from '~/modules/common/components';
import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';
import { isoToReplicon } from '~/util/date';

const useStyles = makeStyles({
  value: {
    width: theme.spacing(30)
  }
});

const getMonthLabel = date => {
  return DateTime.utc(date.year, date.month, date.day).toLocaleString({
    month: 'long',
    year: 'numeric'
  });
};

export const MonthFormatter = ({ field, record }) => {
  const classes = useStyles();
  const value = getMonthLabel(isoToReplicon(record[field]));

  return value ? (
    <Typography className={classes.value} variant="body2">
      {value}
    </Typography>
  ) : (
    <NoValue />
  );
};

MonthFormatter.propTypes = {
  field: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired
};

export default MonthFormatter;
